var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { generateReducer, } from "../generators/generator.reducer";
import { refundPaymentStart, refundPaymentSucceeded, refundPaymentFailed, } from "./payin.actions";
import { GENERATOR_PARAMS } from "./payin.constants";
var getExtraDefaultState = function () { return ({
    refund: {},
}); };
var _reducer = generateReducer(GENERATOR_PARAMS, getExtraDefaultState);
var reducer = _reducer;
reducer.on(refundPaymentStart.type, function (state, payload) {
    var _a;
    var itemKey = payload.id;
    return __assign(__assign({}, state), { refund: __assign(__assign({}, state.refund), (_a = {}, _a[itemKey] = __assign(__assign({}, state.refund[itemKey]), { isRefunding: true, refundError: undefined }), _a)) });
});
reducer.on(refundPaymentSucceeded.type, function (state, payload) {
    var _a;
    var itemKey = payload.id;
    return __assign(__assign({}, state), { refund: __assign(__assign({}, state.refund), (_a = {}, _a[itemKey] = __assign(__assign({}, state.refund[itemKey]), { isRefunding: false, refundError: undefined }), _a)) });
});
reducer.on(refundPaymentFailed.type, function (state, payload) {
    var _a;
    var itemKey = payload.id;
    return __assign(__assign({}, state), { refund: __assign(__assign({}, state.refund), (_a = {}, _a[itemKey] = __assign(__assign({}, state.refund[itemKey]), { isRefunding: false, refundError: payload.error }), _a)) });
});
// eslint-disable-next-line import/no-default-export
export default reducer;
